import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { TextField } from '@material-ui/core';
import { getFieldLabel } from '../../utils';
import RadioYesNo from '../RadioYesNo';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function PaymentTerms(_ref) {
  let {
    publicProcurementData,
    onChange
  } = _ref;
  const handleSimpleChange = name => event => {
    onChange({
      [name]: event.target.value
    });
  };
  const handleChangeRadio = name => value => {
    onChange({
      [name]: value
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "card",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex-container",
      children: /*#__PURE__*/_jsx("h2", {
        children: /*#__PURE__*/_jsx(Translate, {
          value: "publicProcurement.titles.paymentTerms"
        })
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "row",
      children: [/*#__PURE__*/_jsx("div", {
        className: "col-lg-4 col-md-12 pb-3",
        children: /*#__PURE__*/_jsx(TextField, {
          label: getFieldLabel('publicProcurement.iban', true),
          id: "paymentTerms-iban",
          name: "paymentTerms-iban",
          value: publicProcurementData.iban || '',
          onChange: handleSimpleChange('iban')
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "col-lg-4 col-md-12 pb-3",
        children: /*#__PURE__*/_jsx(TextField, {
          label: getFieldLabel('publicProcurement.bankName', true),
          id: "paymentTerms-bankName",
          name: "paymentTerms-bankName",
          value: publicProcurementData.bankName || '',
          onChange: handleSimpleChange('bankName')
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "col-lg-4 col-md-12 pb-3",
        children: /*#__PURE__*/_jsx(TextField, {
          label: getFieldLabel('publicProcurement.accountNumber', true),
          id: "paymentTerms-accountNumber",
          name: "paymentTerms-accountNumber",
          value: publicProcurementData.accountNumber || '',
          onChange: handleSimpleChange('accountNumber')
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "row pb-3",
      children: /*#__PURE__*/_jsx("div", {
        className: "col-12",
        children: /*#__PURE__*/_jsx(RadioYesNo, {
          id: "paymentTerms-advancePayRequired",
          name: "paymentTerms-advancePayRequired",
          title: getFieldLabel('publicProcurement.advancePayRequired', true),
          value: publicProcurementData.advancePayRequired,
          onChange: handleChangeRadio('advancePayRequired')
        })
      })
    })]
  });
}
PaymentTerms.propTypes = {
  onChange: PropTypes.func.isRequired,
  publicProcurementData: PropTypes.shape({
    iban: PropTypes.string,
    bankName: PropTypes.string,
    accountNumber: PropTypes.string,
    advancePayRequired: PropTypes.bool
  }).isRequired
};
export default PaymentTerms;